import { createApp } from 'vue'
import { createPinia } from 'pinia'
import 'default-passive-events'
import 'element-plus/dist/index.css'
import './assets/style/index.scss'
import 'virtual:svg-icons-register'
import { createHead } from '@vueuse/head'
import App from './App.vue'
import router from './router'
import TvbSvgIcon from '@/components/TvbSvgIcon/index.vue'
import './utils/device'

createApp(App)
    .use(router)
    .use(createHead())
    .use(createPinia())
    .component('tvb-svg-icon', TvbSvgIcon)
    .mount('#programme')
